import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Person_PageMenu_ApiEnum } from './PersonDetailConfigApiInterface';

export enum Config_PlayerContractCreate_ActionsMenu_ApiEnum {
    'archive' = 'archive',
}

export enum Config_PlayerContractCreate_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'form' = 'form',
}

export enum Config_PlayerContractCreate_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_PlayerContractCreate_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_PlayerContractCreate_ApiInterface
    extends ConfigDataInterface<
        Config_PlayerContractCreate_Modules_ApiEnum,
        Config_PlayerContractCreate_ActionsMenu_ApiEnum,
        Config_PlayerContractCreate_ActionsOther_ApiEnum,
        Config_Person_PageMenu_ApiEnum,
        Config_PlayerContractCreate_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
